<template>
    <div class="ManageClusterRequest">
        <div v-for="(request, request_index) in manageRequestList" :key="request_index">
            <div class="title mt-4">{{request.store_name  }}</div>

            <table class="mt-4">
                <thead>
                    <tr>
                        <th>DATE</th>
                        <th>EMPLOYEE</th>
                        <th>TIME</th>
                        <th>DURATION</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(emp, emp_index) in request.emp_list" :key="emp_index">
                        <td>{{ emp.date }}</td>
                        <td>{{ emp.employee_name }}</td>
                        <td>{{ emp.time }}</td>
                        <td>{{ emp.duration + ' Hrs'}}</td>
                        <td>
                            <el-select size="mini" v-model="emp.status" @change="changeStatus(request_index, emp_index)" :class="[emp.status == 'approved' ? 'approved' : emp.status == 'pending' ? 'pending' : emp.status == 'denied' ? 'denied' : 'cancelled']">
                                <el-option
                                    v-for="item in statuses"
                                    :key="item.title"
                                    :label="item.title"
                                    :value="item.value"
                                    :disabled="emp.status == 'denied' || (emp.status == 'approved' && item.value == 'pending')"
                                >
                                </el-option>
                            </el-select>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="!manageRequestList.length" class="no-data-notification">
            No data available
        </div>

        <el-dialog
			title="Deny Request"
			:visible.sync="deny_request_dialog_visible"
            :before-close="closeDenyRequestDialog"
			width="50%"
		>
            <div>
                <el-row>
                    <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
                        <label class="label">Store Name</label>
                    </el-col>

                    <el-col :xs="12" :sm="12" :md="20" :lg="20" :xl="20">
                        <div class="text-descp">{{ selected_emp_request.store }}</div>
                    </el-col>
                </el-row>

                <el-row class="mt-6">
                    <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
                        <label class="label">Employee</label>
                    </el-col>

                    <el-col :xs="12" :sm="12" :md="20" :lg="20" :xl="20">
                        <div class="text-descp">{{ selected_emp_request.employee }}</div>
                    </el-col>
                </el-row>

                <el-row class="mt-6">
                    <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
                        <label class="label">Date</label>
                    </el-col>

                    <el-col :xs="12" :sm="12" :md="20" :lg="20" :xl="20">
                        <div class="text-descp">{{ selected_emp_request.date }}</div>
                    </el-col>
                </el-row>
                
                <el-row class="mt-6">
                    <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
                        <label class="label">Time</label>
                    </el-col>

                    <el-col :xs="12" :sm="12" :md="20" :lg="20" :xl="20">
                        <div class="text-descp">{{ selected_emp_request.time }}</div>
                    </el-col>
                </el-row>

                <el-row class="mt-6">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <label class="label">Reason <span style="color: red;">*</span></label>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mt-2">
                        <el-input type="textarea" v-model="reason" v-validate="'required'" placeholder="Reason" :rows="4" name="Reason" resize="none"></el-input>

                        <p>
                            <span :v-show="errors.has(`Reason`)" class=" text-red-dark text-xs"
                            >
                                {{ errors.first(`Reason`) }}
                            </span>
                        </p>
                    </el-col>
                </el-row>
            </div>

			<span slot="footer" class="dialog-footer">
				<el-button type="warning" size="mini" class="action-btn" @click="closeDenyRequestDialog()">Cancel</el-button>
				<el-button type="warning" size="mini" class="action-btn" @click="updateReason()" :loading="is_status_updating">Update</el-button>
			</span>
		</el-dialog>
    </div>
</template>

<script>
import moment from 'moment';
import labourPlanningService from '../../../../services/labourPalnningService';

export default {
    name: 'ManageClusterRequest',
    
    props: {
        manageRequestList: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            moment: moment,
            statuses: [
                {
                    title: 'APPROVE',
                    value: 'approved'
                },
                {
                    title: 'PENDING',
                    value: 'pending'
                },
                {
                    title: 'DENY',
                    value: 'denied'
                },
                // {
                //     title: 'CANCELLED',
                //     value: 'cancelled'
                // }
            ],
            deny_request_dialog_visible: false,
            reason: '',
            selected_emp_request: {},
            is_status_updating: false
        }
    },

    methods: {
        changeStatus(cluster_index, emp_index){
            // reset previously selected fields
            this.selected_emp_request = {};
            this.reason = '';   

            // selected status is deny then open dialog to enter reason
            if(this.manageRequestList[cluster_index].emp_list[emp_index].status == 'denied'){
                this.selected_emp_request = {
                    cluster_index: cluster_index,
                    emp_index: emp_index,
                    store: this.manageRequestList[cluster_index].emp_list[emp_index].requesting_outlet_name,
                    employee: this.manageRequestList[cluster_index].emp_list[emp_index].employee_name,
                    date: this.manageRequestList[cluster_index].emp_list[emp_index].date,
                    time: this.manageRequestList[cluster_index].emp_list[emp_index].time,
                    reason: this.manageRequestList[cluster_index].emp_list[emp_index].reason
                };

                this.deny_request_dialog_visible = true;        //open deny request dialog
            }else{          //otherwise update status directly

                this.updateStatus(cluster_index, emp_index);
            }
        },

        // called from dialog
        updateReason(){
            this.$validator.validateAll().then(result => {
                if(result){
                    this.is_status_updating = true;             //enabled laoder
                    // called update status function -- sent cluster index and emp index
                    this.updateStatus(this.selected_emp_request.cluster_index, this.selected_emp_request.emp_index);
                }
            })
        },

        updateStatus(cluster_index, emp_index){
            let params = {
                cluster_employee_request: this.manageRequestList[cluster_index].emp_list[emp_index].id,
                status: this.manageRequestList[cluster_index].emp_list[emp_index].status == 'denied' ? 'rejected' : this.manageRequestList[cluster_index].emp_list[emp_index].status
            }

            // if status is deny then assign reason of deny to params
            if(this.manageRequestList[cluster_index].emp_list[emp_index].status == 'denied'){
                params.reason = this.reason;
            }

            labourPlanningService.approveClusterRequest(params)
            .then(response =>{
                if (response.status == 200) {
                    this.$notify.success({
                        title: "Success",
                        message: 'Request status changed..!'
                    });

                    this.deny_request_dialog_visible = false;           //close deny request dialog
                }else{
                    this.$notify.error({
                        title: "Error",
                        message: 'Fail to change request status..!'
                    });

                    // if api failed then reset status
                    this.manageRequestList[cluster_index].emp_list[emp_index].status = this.manageRequestList[cluster_index].emp_list[emp_index].raw_status;
                }

                this.is_status_updating = false;    //disabled loader
            })
            .catch(e =>{
                // console.log('error', e.response.data);
                let msg = JSON.parse(e.response.data).msg;
                this.$notify.error({
                    title: "Error",
                    message: msg
                });
                // if api failed then reset status
                this.manageRequestList[cluster_index].emp_list[emp_index].status = this.manageRequestList[cluster_index].emp_list[emp_index].raw_status;
                this.$forceUpdate();
                this.is_status_updating = false;    //disabled loader
            })
        },

        closeDenyRequestDialog(){
            // on dialog cancel reset status
            this.manageRequestList[this.selected_emp_request.cluster_index].emp_list[this.selected_emp_request.emp_index].status = this.manageRequestList[this.selected_emp_request.cluster_index].emp_list[this.selected_emp_request.emp_index].raw_status;

            this.deny_request_dialog_visible = false;
        }
    },
}
</script>
<style lang="scss" scoped>
.ManageClusterRequest{
    .title{
        font-size: 0.8rem;
        font-weight: bold;
        text-transform: uppercase;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        // border: 1px solid #bebebe;
    }

//   thead, tbody, tr, td, th {
//     display: block;
//   }
//   tbody tr{
//     // border-bottom: 1px solid #bebebe;
//   }
//   tr:after {
//     content: ' ';
//     display: block;
//     visibility: hidden;
//     clear: both;
//   }
    thead th {
        // height: 25px;
        // line-height: 30px;
        height: 35px;
        text-align: left;
        color: #707070;
        background-color: #f2f2f2!important;
        text-transform: uppercase;
    }

    tbody td, thead th {
        width: 20%;
        // float: left;
        text-align: center;
        font-size: 13px;
    }

    td{
        height: 50px;
    }

    tbody tr{
        border-bottom: 1px solid #eee;
    }

    .status-badge{
        padding: 3px;
        border-radius: 4px;
        font-size: 0.7rem;
        max-width: 120px;
        margin: 0 auto;
        text-transform: uppercase;
    }
    
    .label{
        font-size: 0.9rem;
        font-weight: bold;
        margin-bottom: 3px;
    }

    .action-btn {
        background-color: #E29D5A;
        border-color: #E29D5A;
        color: #fff;
    }
    
    .no-data-notification{
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: #e29d5a;
        padding: 15px;
    }
    .label{
        font-size: 0.8rem;
        font-weight: bold;
        // color: #000;
    }
    .text-descp{
        font-size: 0.9rem;
        color: #7a7a7a;
        text-transform: capitalize;
    }
}
</style>
<style lang="scss">
.approved{
    .el-input__inner{
        border: 1px solid #3e8e5d;
        background-color: #3e8e5d;
        color: #fff;
    }
    .el-input .el-select__caret{
        color: #fff;
    }
}

.pending{
    .el-input__inner{
        border: 1px solid #e29d5a;
        background-color: #e29d5a;
        color: #fff;
    }
    .el-input .el-select__caret{
        color: #fff;
    }
}

.denied{
    .el-input__inner{
        border: 1px solid #d60918;
        background-color: #d60918;
        color: #fff;
    }
    .el-input .el-select__caret{
        color: #fff;
    }
}

.cancelled{
    .el-input__inner{
        border: 1px solid #ddd;
        background-color: #fff;
        color: #999;
    }
    .el-input .el-select__caret{
        color: #999;
    }
}
</style>